// Development environment now reads from window.APP_CONFIG injected by Docker (same as production)
declare global {
  interface Window {
    APP_CONFIG?: {
      apiBase: string;
      downloaderApiBase: string;
      oidc: {
        issuer: string;
        clientId: string;
        redirectUri: string;
        scope?: string;
        codeChallengeMethod?: string;
      };
      oidcArdaco: {
        issuer: string;
        clientId: string;
        redirectUri: string;
        scope?: string;
        codeChallengeMethod?: string;
      };
    };
  }
}

export const environment = {
  production: false,
  apiBase: ((window as any).APP_CONFIG?.apiBase !== undefined && (window as any).APP_CONFIG?.apiBase !== '') ? (window as any).APP_CONFIG?.apiBase : 'http://localhost:9090',
  downloaderApiBase: ((window as any).APP_CONFIG?.downloaderApiBase !== undefined && (window as any).APP_CONFIG?.downloaderApiBase !== '') ? (window as any).APP_CONFIG?.downloaderApiBase : 'http://localhost:9090',
  oidc: {
    issuer: (window as any).APP_CONFIG?.oidc?.issuer || 'https://playground.tsp.ardaco.com/realms/qsign_realm_playground',
    clientId: (window as any).APP_CONFIG?.oidc?.clientId || 'qsign_edesk_fe',
    redirectUri: (window as any).APP_CONFIG?.oidc?.redirectUri || 'http://localhost:4200/qsign-edesk-frontend/sso-redirect',
    scope: (window as any).APP_CONFIG?.oidc?.scope || 'openid profile email',
    codeChallengeMethod: (window as any).APP_CONFIG?.oidc?.codeChallengeMethod || 'S256'
  },
  oidcArdaco: {
    issuer: (window as any).APP_CONFIG?.oidcArdaco?.issuer || 'https://playground.tsp.ardaco.com/realms/qsign_realm_playground',
    clientId: (window as any).APP_CONFIG?.oidcArdaco?.clientId || 'qsign_edesk_fe',
    redirectUri: (window as any).APP_CONFIG?.oidcArdaco?.redirectUri || 'http://localhost:4200/qsign-edesk-frontend/sso-redirect',
    scope: (window as any).APP_CONFIG?.oidcArdaco?.scope || 'openid profile email',
    codeChallengeMethod: (window as any).APP_CONFIG?.oidcArdaco?.codeChallengeMethod || 'S256'
  },
  webview: {
    enableSilentLogin: true,
    cookieName: 'KEYCLOAK_IDENTITY'
  }
};

// Debug logging
console.log('=== ENVIRONMENT CONFIG DEBUG (DEV) ===');
console.log('window.APP_CONFIG:', (window as any).APP_CONFIG);
console.log('environment.apiBase:', environment.apiBase);
console.log('environment.downloaderApiBase:', environment.downloaderApiBase);
console.log('=======================================');
